<template>
    <div>
        <vs-sidebar
        click-not-close
        position-right
        default-index="1"
        color="primary"
        class="add-new-data-sidebar items-no-padding"
        spacer
        parent="body"
        v-model="isActive"
        >
            <div class="mt-6 mb-4 flex items-center justify-between px-6">
                <h4>
                    {{ this.context === 'update' ? 'Editar Produto': 'Criar Produto' }}
                </h4>
                <feather-icon
                icon="XIcon"
                class="cursor-pointer"
                @click="closeSidebar"
                />
            </div>
            <vs-divider class="mb-0"/>

            <div>
                <vs-input
                id="input-adjustment"
                label="Nome do Produto"
                class="mt-3 ml-8 w-5/6"
                name="nome"
                v-validate="'required'"
                v-model="productData.name"
                />
            </div>
            <span
                class="text-danger text-sm ml-10"
                v-show="errors.has('nome')"
            >
                {{ errors.first('nome') }}
            </span>

            <div>
                <vs-input
                id="input-adjustment"
                type="number"
                label="Preço"
                class="mt-3 ml-8 w-5/6"
                name="preço"
                v-validate="'required'"
                v-model="productData.price"
                />
            </div>
            <span
                class="text-danger text-sm ml-10"
                v-show="errors.has('preço')"
            >
                {{ errors.first('preço') }}
            </span>

            <div>
                <vs-input
                id="input-adjustment"
                type="number"
                label="Preço com Desconto"
                class="mt-3 ml-8 w-5/6"
                v-model="productData.discount_price"
                />
            </div>
            
            <div>
                <vs-input
                id="input-adjustment"
                label="Categoria"
                class="mt-3 ml-8 w-5/6"
                name="categoria"
                v-validate="'required'"
                v-model="productData.category"
                />
            </div>
            <span
                class="text-danger text-sm ml-10"
                v-show="errors.has('categoria')"
            >
                {{ errors.first('categoria') }}
            </span>

            <div>
                <vs-input
                id="input-adjustment"
                label="Marca do Produto"
                class="mt-3 ml-8 w-5/6"
                name="marca"
                v-model="productData.brand"
                />
            </div>

            <div>
                <vs-input
                id="input-adjustment"
                label="Código do Produto"
                class="mt-3 ml-8 w-5/6"
                name="codigo"
                v-model="productData.bar_code"
                v-validate="'required'"
                />
            </div>
            <span
                class="text-danger text-sm ml-10"
                v-show="errors.has('codigo')"
            >
                {{ errors.first('codigo') }}
            </span>
            
            <div>
                <vs-input
                id="input-adjustment"
                label="Princípio Ativo"
                class="mt-3 ml-8 w-5/6"
                name="princípio ativo"
                v-model="productData.active_principle"
                />
            </div>
            
            <div>
                <vs-input
                id="input-adjustment"
                label="Laboratório (opcional)"
                class="mt-3 ml-8 w-5/6"
                name="Laboratório"
                v-model="productData.laboratory"
                />
            </div>
            
            <div class="group-checkbox">
                <div class="group-div-checkbox">
                    <vs-checkbox
                    id="input-adjustment"
                    label="O produto é um medicamento?"
                    class=""
                    name="é medicamento"
                    v-validate="'required'"
                    v-model="productData.is_medication"
                    />
                    <label for class="vs-input--label">É um medicamento ?</label>
                </div>
                <span
                    class="text-danger text-sm ml-10"
                    v-show="errors.has('é medicamento')"
                >
                    {{ errors.first('é medicamento') }}
                </span>

                <div class="group-div-checkbox">
                    <vs-checkbox
                    id="input-adjustment"
                    label="Precisa de Prescrição Médica?"
                    class=""
                    name="prescrição"
                    v-validate="'required'"
                    v-model="productData.need_prescription"
                    />
                    <label for class="vs-input--label">Precisa de Prescrição ?</label>
                </div>
                <span
                    class="text-danger text-sm ml-10"
                    v-show="errors.has('prescrição')"
                >
                    {{ errors.first('prescrição') }}
                </span>
            </div>
            
            <div>
                <vs-textarea
                id="input-adjustment"
                label="Descrição"
                class="mt-3 ml-8 w-5/6"
                name="descrição"
                v-model="productData.description"
                />
            </div>

            <div>
                <span class="flex items-center text-center flex-centered ml-8">
                    Imagem do Produto
                </span>
                <div class="mb-8 image-items-card flex items-center justify-center">
                    <div class="vx-col">
                        <upload
                            ref="uploadComponent"
                            :action="uploadApiUrl"
                            fileName="file"
                            :headers="{
                                Authorization: 'Bearer ' + bearer
                            }"
                            text="Escolher Arquivo"
                            automatic
                            :limit="1"
                            :single-upload="true"
                            @on-success="successUploadImage"
                            @on-error="errorUploadImage"
                            @on-delete="deleteUploadImage"
                        />
                    </div>
                </div>
            </div>

            <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
                <vs-button class="mr-6" @click="checkDiscountPrice()">
                    Salvar
                </vs-button>
                <vs-button type="border" color="danger" @click="closeSidebar">
                    Cancelar
                </vs-button>
            </div>

        </vs-sidebar>
    </div>
</template>

<script>
    import Upload from '@/components/upload/Upload';
    import { hasFeature } from '@/utils';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import ERP from '@/http/requests/erp'

    export default {
        components: {
            VuePerfectScrollbar,
            Upload
        },
        data() {
            return {
                productData: {
                    id: undefined,
                    name: '',
                    price: undefined,
                    discount_price: undefined,
                    amount: 0,
                    description: '',
                    category: '',
                    image: '',
                    brand: '',
                    bar_code: '',
                    laboratory: '',
                    is_medication: false,
                    active_principle: '',
                    need_prescription: false           
                },
                erpList: [],
                erpFeature: false,
                selectedErp: {
                    id: null,
                    corporate_name: 'Não Inserir',
                    erp_id: null
                }
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            context: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: true,
                default: false
            },
            isIphoneIos: {
                type: Boolean,
                required: true
            },
        },
        computed: {
            uploadApiUrl() {
                return localStorage.getItem('baseUrl') + '/api/file/upload'
            },
            bearer() {
                return this.$store.state.auth.bearer
            }
        },
        methods: {
            successUploadImage(response) {
                this.$vs.notify({
                    color: 'success',
                    title: 'Arquivo carregado com sucesso!',
                    text: response.data.message
                })

                this.productData.image = response.data.fileUrl
            },
            deleteUploadImage() {
                this.productData.image = null
                this.$refs.uploadComponent.removeFile(null, true)
            },
            errorUploadImage(response) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Ocorreu um erro ao subir o arquivo!',
                    text: response.data.message
                })
            },
            createData() {
                console.log('this.selectedErp', this.selectedErp);
                const data = {
                    name: this.productData.name,
                    erp_id: this.selectedErp.id,
                    brand: this.productData.brand,
                    image: this.productData.image,
                    price: this.productData.price,
                    amount: this.productData.amount,
                    bar_code: this.productData.bar_code,
                    category: this.productData.category,
                    laboratory: this.productData.laboratory,
                    description: this.productData.description,
                    is_medication: this.productData.is_medication,
                    discount_price: this.productData.discount_price,
                    active_principle: this.productData.active_principle,
                    need_prescription: this.productData.need_prescription,
                }
                console.log('CREATEDATA', data);

                this.$validator.validateAll().then(async (response) =>  {
                    if (!response) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Algo deu errado:',
                            text: 'Existem campos obrigatórios não preenchidos!'
                        })
                        return;
                    } else {
                        await this.$store.dispatch("product/create", data)
                        .then((response) => {
                            this.$vs.notify({
                                color: 'success',
                                title: 'Sucesso!',
                                text: 'Produto criado com sucesso!'
                            })
                            this.closeSidebar();
                        })
                        .catch((exception) => {
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Ocorreu um erro ao criar o produto!',
                                text: 'Erro ao criar o produto, por favor nos contate para corrigir-mos!'
                            });
                            console.log(exception);
                        });
                    }
                })
            },
            async updateData() {
                const data = {
                    id: this.productData.id,
                    name: this.productData.name,
                    price: this.productData.price,
                    amount: this.productData.amount,
                    description: this.productData.description,
                    category: this.productData.category,
                    image: this.productData.image,
                    brand: this.productData.brand,
                    bar_code: this.productData.bar_code,
                    is_medication: this.productData.is_medication,
                    discount_price: this.productData.discount_price,
                    active_principle: this.productData.active_principle,
                    need_prescription: this.productData.need_prescription,
                    laboratory: !this.productData.laboratory ? '' :this.productData.laboratory
                }

                await this.$store.dispatch("product/update", data)
                .then((response) => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Sucesso!',
                        text: 'Produto atualizado com sucesso!'
                    })
                })
                .catch((exception) => {
                    console.log(exception)
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Ocorreu um erro ao atualizar os dados!',
                        text: 'Erro ao atualizar os dados, por favor nos contate para corrigir-mos!'
                    });
                    console.log(exception);
                });

                this.closeSidebar(); 
            },
            closeSidebar() {
                this.deleteUploadImage();
                this.$emit('isActiveFalse');
            },
            checkDiscountPrice() {
                
                if (this.productData.discount_price >= this.productData.price) {
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Atenção!',
                        text: 'Não é possiver definir o valor de desconto maior ou igual que o preço convencional',
                        time: 6000,
                    })
                }

                this.context === 'create' ? this.createData() : this.updateData()
            }
        },
        watch: {
            isActive(val) {
                if (val) {
                    this.productData.id                = this.data.id
                    this.productData.name              = this.data.name
                    this.productData.price             = this.data.price
                    this.productData.image             = this.data.image
                    this.productData.brand             = this.data.brand
                    this.productData.amount            = this.data.amount
                    this.productData.bar_code          = this.data.bar_code
                    this.productData.category          = this.data.category
                    this.productData.laboratory        = this.data.laboratory
                    this.productData.description       = this.data.description
                    this.productData.is_medication     = this.data.is_medication
                    this.productData.discount_price    = this.data.discount_price
                    this.productData.active_principle  = this.data.active_principle
                    this.productData.need_prescription = this.data.need_prescription

                }
            }
        },
        async mounted() {
            this.erpFeature = await hasFeature('erps');
            if (this.erpFeature) {
                
                // 2 é o id do alpha7
                await ERP.fetchByErpId(2)
                .then((response) => {
                    this.erpList = response.data.data.getErp;
                })
            }

        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .vs-sidebar {
        z-index: 52010;
        width: 400px;
        max-width: 90vw;
    }
    ::v-deep .vs-sidebar--background {
        z-index: 52010;
    }


    .add-new-data-sidebar.items-no-padding .vs-sidebar--items {
        overflow-y: auto !important;
    }
    .group-checkbox {
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        margin: 12px 0 12px 0;
    }
    .btn-drop .parent-dropdown .vs-button-primary {
        width: 194px;
    }
</style>